import React from "react";
import { Separator } from "../../components/ui/separator";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "../../components/ui/card";
import { Icons } from "../../utils/icons";
import { Link } from "react-router-dom";

export default function AboutCompany() {
  return (
    <Card className="w-full h-full">
      <CardHeader className="space-y-2">
        <CardTitle className="text-xl font-semibold flex items-center gap-2">
          <Icons.building className="w-5 h-5 text-accent" />
          <span className="text-accent">About the Company</span>
        </CardTitle>
        <div className="text-sm text-muted-foreground space-y-3">
          <p>
            Retire Planning Max (RPM) is a premier calculator designed
            specifically for insurance and benefit specialists who cater to the
            Federal Employee market. Trusted by hundreds of agencies and
            individual agents, RPM streamlines the complex process of calculating
            Federal Employee retirement benefits, including Thrift Savings Plan
            (TSP), Social Security, and Federal Employee Retirement System (FERS)
            benefits.
          </p>
          <p>
            This comprehensive software solution simplifies retirement
            planning by integrating all the key components of a federal employee's
            retirement package. RPM's user-friendly interface and robust features
            make it an essential tool for professionals in the field.
          </p>
          <p>
            By providing accurate and efficient retirement calculations, RPM helps ensure that
            federal employees can plan their retirements with confidence and
            clarity. The software's ability to handle the intricacies of federal
            retirement benefits makes it a valuable asset for those dedicated to
            assisting federal employees in achieving their retirement goals.
          </p>
        </div>
      </CardHeader>
      <CardContent>
        <Separator className="my-4" />
        <div className="flex h-5 items-center space-x-4 text-sm">
          <Link 
            to="/" 
            className="text-muted-foreground hover:text-foreground transition-colors"
          >
            Dashboard
          </Link>
          <Separator orientation="vertical" />
          <Link 
            to="/clients/" 
            className="text-muted-foreground hover:text-foreground transition-colors"
          >
            Clients
          </Link>
          <Separator orientation="vertical" />
          <Link 
            to="/feedback/" 
            className="text-muted-foreground hover:text-foreground transition-colors"
          >
            Feedback
          </Link>
        </div>
      </CardContent>
    </Card>
  );
}
